/**
 * Event Months
 * Create the dynamic months display based on the events listing
 *
 * @todo Need to change the active link when clicked
 */
import React from 'react'
import { Link } from 'react-scroll'

// eslint-disable-next-line import/prefer-default-export
import { Hash } from '../..'

export type EventMonthsProps = {
  active: string
  handleClick?: (itemUpper: string) => void
  months: string[]
  sort: string
}

export const EventListingsMonths = ({
  active,
  handleClick = () => {},
  months,
  sort
}: EventMonthsProps) => {
  const monthMap = () => {
    if (months.length <= 0) {
      return false
    }

    const date = new Date(`1 ${months[0]} 1999`)
    const dateStrings = []
    const dateFormatOptions = { month: 'long' }
    let i
    let len

    for (i = 0, len = 12; i < len; i += 1) {
      if (sort === 'past') {
        date.setMonth(date.getMonth() + 1)
      } else {
        date.setMonth(date.getMonth() - 1)
      }
      dateStrings.unshift(date.toLocaleString('en-US', dateFormatOptions))
    }

    return dateStrings.map((item, index) => {
      const itemUpper = item.toUpperCase()

      /* get eventRowWrapper elemnt by id to use it later to get scrollbar container linked to 
      so that we dont pick other scrollbar's if available */
      const eventRowWrapper = document.getElementById(
        'event__wrapper--row-wrapper'
      )
      const scrollbarContainer =
        eventRowWrapper &&
        eventRowWrapper.getElementsByClassName('scrollbar-container')[0]

      /* set id to scrollbarContainer element to pass it to Link comp as identifier
      of the container to look for scroll event. Currently no Id is there for PerfectScrollbar comp. */
      if (scrollbarContainer !== undefined && scrollbarContainer !== null)
        scrollbarContainer.id = 'scrollbar-container'

      return (
        <div
          className={
            active === itemUpper ? `js-date-toggle active` : 'js-date-toggle'
          }
          key={Hash(['eventTab', item, index].join('#'))}
        >
          {months.includes(itemUpper) ? (
            <Link
              duration={750}
              onClick={() => handleClick(itemUpper)}
              smooth
              to={itemUpper}
              containerId="scrollbar-container"
            >
              {item}
            </Link>
          ) : (
            item
          )}
        </div>
      )
    })
  }

  return (
    <div className="event__wrapper--date">
      <div className="va">{monthMap()}</div>
    </div>
  )
}
